export const LANDLORD_HOME_PATH = '/landlord/inner/root';
